import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaShieldAlt, FaUserSecret, FaSyncAlt, FaLock, FaUserEdit, FaBell, FaKey } from 'react-icons/fa'; // Import icons from react-icons
import Footer from '../footer/Footer'; // Import Footer component

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            {/* Header */}
            <header className="border-b p-4" style={{ backgroundColor: "#0a3891", color: "white" }}>
                <div className="container mx-auto flex flex-wrap justify-between items-center">
                    <div className="text-2xl md:text-3xl font-bold flex items-center gap-2">
                        <h1>Prodyt</h1>
                    </div>
                    {/* Hamburger Menu Button */}
                    <button
                        className="block md:hidden text-white focus:outline-none"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
                    </button>
                    {/* Navigation Menu */}
                    <nav
                        className={`${
                            menuOpen ? 'block' : 'hidden'
                        } absolute top-12 right-4 bg-blue-900 z-10 rounded-md md:static md:w-auto md:bg-transparent md:flex flex-col md:flex-row gap-4 md:gap-6`}
                    >
                        <Link to="/" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Home
                        </Link>
                        <Link to="/about" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            About Us
                        </Link>
                        <Link to="/privacy-policy" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Privacy Policy
                        </Link>
                        <Link to="/help-center" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Help Center
                        </Link>
                        <Link to="/terms-of-service" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Terms of Service
                        </Link>
                        <Link to="/delete-account" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Delete Account
                        </Link>
                    </nav>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1 flex items-center justify-center p-4">
                <div className="bg-white border border-gray-300 rounded-lg shadow-lg p-6 md:p-8 max-w-lg md:max-w-3xl w-full">
                    <h1 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 text-center" style={{ color: "#0a3891" }}>
                        {t('privacy_policy_title')}
                    </h1>
                    <p className="text-sm md:text-lg text-gray-600 mb-6 md:mb-8 text-center">
                        {t('privacy_policy_intro')}
                    </p>
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-blue-600">
                        {t('privacy_policy_information_title')}
                    </h2>
                    <ul className="space-y-6 mb-8">
                        <li className="flex items-center bg-blue-50 border-l-4 border-blue-500 p-4 rounded shadow-sm">
                            <FaUserSecret className="text-blue-500 text-2xl md:text-3xl mr-4" />
                            <span className="text-sm md:text-lg text-gray-700">{t('privacy_policy_information_point1')}</span>
                        </li>
                        <li className="flex items-center bg-blue-50 border-l-4 border-blue-500 p-4 rounded shadow-sm">
                            <FaShieldAlt className="text-blue-500 text-2xl md:text-3xl mr-4" />
                            <span className="text-sm md:text-lg text-gray-700">{t('privacy_policy_information_point2')}</span>
                        </li>
                    </ul>
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-yellow-600">
                        {t('privacy_policy_usage_title')}
                    </h2>
                    <ul className="space-y-6 mb-8">
                        <li className="flex items-center bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded shadow-sm">
                            <FaSyncAlt className="text-yellow-500 text-2xl md:text-3xl mr-4" />
                            <span className="text-sm md:text-lg text-gray-700">{t('privacy_policy_usage_point1')}</span>
                        </li>
                        <li className="flex items-center bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded shadow-sm">
                            <FaLock className="text-yellow-500 text-2xl md:text-3xl mr-4" />
                            <span className="text-sm md:text-lg text-gray-700">{t('privacy_policy_usage_point2')}</span>
                        </li>
                    </ul>
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-purple-600">
                        {t('privacy_policy_updates_title')}
                    </h2>
                    <ul className="space-y-6 mb-8">
                        <li className="flex items-center bg-purple-50 border-l-4 border-purple-500 p-4 rounded shadow-sm">
                            <FaBell className="text-purple-500 text-2xl md:text-3xl mr-4" />
                            <span className="text-sm md:text-lg text-gray-700">{t('privacy_policy_updates_point1')}</span>
                        </li>
                    </ul>
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-green-600">
                        {t('privacy_policy_security_title')}
                    </h2>
                    <ul className="space-y-6 mb-8">
                        <li className="flex items-center bg-green-50 border-l-4 border-green-500 p-4 rounded shadow-sm">
                            <FaKey className="text-green-500 text-2xl md:text-3xl mr-4" />
                            <span className="text-sm md:text-lg text-gray-700">{t('privacy_policy_security_point1')}</span>
                        </li>
                    </ul>
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-green-600">
                        {t('privacy_policy_rights_title')}
                    </h2>
                    <ul className="space-y-6 mb-8">
                        <li className="flex items-center bg-green-50 border-l-4 border-green-500 p-4 rounded shadow-sm">
                            <FaUserEdit className="text-green-500 text-2xl md:text-3xl mr-4" />
                            <span className="text-sm md:text-lg text-gray-700">{t('privacy_policy_rights_point1')}</span>
                        </li>
                    </ul>
                    <p className="text-sm md:text-lg text-gray-600 mb-6 md:mb-8 text-center">
                        {t('privacy_policy_contact')}
                    </p>
                </div>
            </main>

            {/* Footer */}
            {/* <footer className="border-t p-4" style={{ backgroundColor: "#0a3891", color: "white" }}>
                <div className="container mx-auto text-center text-xs md:text-sm">
                    <p>&copy; {new Date().getFullYear()} Prodyt. All rights reserved.</p>
                </div>
            </footer> */}
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;